$(function () {
    $('.artikel-slide-gallery').each(function () {
        var $slider = $(this),
            slider = this,
            showNextIndex = 1,
            activeIndex = 0,
            slideAnimation = $('.slideContentWrapper', $slider),
            navigationCounter = $('.navigation-counter', $slider),
            touchEventStart = null,
            touchEventEnd = null,
            $navButtons = $('.navigationButton', $slider);

        $navButtons.each(function () {
            $(this).click(function () {
                navigationSlide($(this).data('direction'));
            });
        });

        // fade into the first slide content
        hideAndShowElements('', -10);

        slider.addEventListener('touchstart', function (e) {
            handleTouchStart(e);
        }, {passive: true});

        slider.addEventListener('touchend', function (e) {
            handleTouchEnd(e);
        }, {passive: true});

        function refreshHeight() {
            $('.slide-placeholder', slider)
                .height($('.fadeIn .image-wrapper', slider)
                .outerHeight());
        }

        function handleTouchStart(e) {
            touchEventStart = e.touches[0].clientX;
        }

        function handleTouchEnd(e) {
            touchEventEnd = e.changedTouches[0].clientX;

            if (touchEventStart < touchEventEnd && (touchEventEnd - touchEventStart) > 30) {
                navigationSlide('back');
            }

            if (touchEventStart > touchEventEnd && (touchEventStart - touchEventEnd) > 30) {
                navigationSlide('next');
            }
        }

        function checkAnimationIndex(n) {
            showNextIndex = n;

            if (n >= slideAnimation.length) {
                showNextIndex = 0;
            }

            if (n < 0) {
                showNextIndex = slideAnimation.length - 1;
            }

            return showNextIndex;
        }

        function hideAndShowElements(direction, n) {
            if (n === -10) {
                // INITIALIZE THE FIRST SLIDE CONTENT
                slideAnimation[0].className = 'slideContentWrapper fadeIn';
                activeIndex = 0;
                showNextIndex = 0;
                refreshHeight();
            } else {
                showNextIndex = checkAnimationIndex(n);

                direction = (direction === 'dot' && showNextIndex > activeIndex ? 'next' : direction);

                if (direction === 'next') {
                    slideAnimation[activeIndex].className = 'slideContentWrapper slideFromLeftOut';
                    slideAnimation[showNextIndex].className = 'slideContentWrapper slideFromLeftIn';
                } else {
                    slideAnimation[activeIndex].className = 'slideContentWrapper slideFromRightOut';
                    slideAnimation[showNextIndex].className = 'slideContentWrapper slideFromRightIn';
                }
                activeIndex = showNextIndex;
                refreshHeight();
            }

            // change slide counter
            setTimeout(function () {
                var counterText = (activeIndex + 1) + ' / ' + slideAnimation.length;
                navigationCounter[0].innerHTML = counterText;
                navigationCounter[1].innerHTML = counterText;
            }, 200);

            activeIndex = showNextIndex;
        }

        function navigationSlide(direction) {
            if (direction === 'next') {
                hideAndShowElements('next', ++showNextIndex);
            } else {
                hideAndShowElements('back', --showNextIndex);
            }
        }

        $(window).on('load resize', function () {
            refreshHeight();
        });
    });
});

